module.exports = __webpack_public_path__ + "img/sustainability.19844e4.webp";